import { Activities } from '@brandandcelebrities/activities-themes';
const activities = new Activities();

export default activities.locale('fr-FR').fullPath().sort().get();
